var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex items-start pb-2" }, [
    _c("label", { staticClass: "flex items-center h-4 switch" }, [
      _c("input", {
        staticClass: "toggle_checkbox relative",
        attrs: { id: _vm.id, type: "checkbox" },
        domProps: { checked: _vm.selected },
        on: { change: _vm.updateVal },
      }),
      _c("span", { staticClass: "slider round" }, [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "14",
              height: "14",
              viewBox: "0 0 14 14",
              fill: "none",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M12.469 2.59766H11.5133C11.3793 2.59766 11.2522 2.65918 11.1701 2.76445L5.53323 9.90527L2.8303 6.48047C2.78941 6.42855 2.73729 6.38658 2.67786 6.35769C2.61842 6.3288 2.55322 6.31375 2.48714 6.31367H1.53147C1.43987 6.31367 1.38928 6.41895 1.44534 6.49004L5.19006 11.2342C5.36506 11.4557 5.70139 11.4557 5.87776 11.2342L12.5551 2.77266C12.6112 2.70293 12.5606 2.59766 12.469 2.59766Z",
                fill: "white",
              },
            }),
          ]
        ),
      ]),
      _c("span", { staticClass: "iconRight" }, [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "14",
              height: "14",
              viewBox: "0 0 14 14",
              fill: "none",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M7.70831 7L11.2972 2.72207C11.3573 2.65098 11.3067 2.54297 11.2138 2.54297H10.1228C10.0585 2.54297 9.99698 2.57168 9.9546 2.6209L6.99464 6.14961L4.03468 2.6209C3.99366 2.57168 3.93214 2.54297 3.86652 2.54297H2.7755C2.68253 2.54297 2.63195 2.65098 2.6921 2.72207L6.28097 7L2.6921 11.2779C2.67863 11.2938 2.66998 11.3132 2.66719 11.3338C2.6644 11.3544 2.66759 11.3754 2.67637 11.3942C2.68515 11.4131 2.69916 11.429 2.71673 11.4402C2.7343 11.4513 2.7547 11.4571 2.7755 11.457H3.86652C3.93077 11.457 3.9923 11.4283 4.03468 11.3791L6.99464 7.85039L9.9546 11.3791C9.99562 11.4283 10.0571 11.457 10.1228 11.457H11.2138C11.3067 11.457 11.3573 11.349 11.2972 11.2779L7.70831 7Z",
                fill: "white",
              },
            }),
          ]
        ),
      ]),
    ]),
    _c("div", { staticClass: "ml-3 text-sm leading-5" }, [
      _c(
        "label",
        { staticClass: "font-medium text-gray-700", attrs: { for: _vm.id } },
        [
          _c("span", { staticClass: "slider2" }),
          _vm._v(" " + _vm._s(_vm.name) + " "),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }